
import { Navigate, Route } from 'react-router-dom';

import { Layout } from 'components/Layout';
import { DashboardProvider } from 'context/Dashboards';
import { PersistentStateProvider } from 'context/PersistentState';
import { PluginProvider } from 'context/Plugin';
import { RedirectProvider } from 'context/Redirect';
import { StylingProvider } from 'context/Styling';
import { TrackingProvider } from 'context/Tracking';
import { UserProvider } from 'context/User';
import { ForgotPassword } from 'pages/ForgotPassword';
import { forgotPasswordRoutes } from 'pages/ForgotPassword/routes';
import { GrafanaSso } from 'pages/GrafanaSso';
import { grafanaSsoRoutes } from 'pages/GrafanaSso/routes';
import { Invites } from 'pages/Invites';
import { invitesRoutes } from 'pages/Invites/routes';
import { MfaLogin } from 'pages/MfaLogin';
import { mfaLoginRoutes } from 'pages/MfaLogin/routes';
import { MfaRecovery } from 'pages/MfaRecovery';
import { mfaRecoveryRoutes } from 'pages/MfaRecovery/routes';
import { MfaSetup } from 'pages/MfaSetup';
import { mfaSetupRoutes } from 'pages/MfaSetup/routes';
import { RedirectTo } from 'pages/RedirectTo';
import { redirectToRoutes } from 'pages/RedirectTo/routes';
import { SignIn } from 'pages/SignIn';
import { signInRoutes } from 'pages/SignIn/routes';
import { SignUp } from 'pages/SignUp';
import { signUpRoutes } from 'pages/SignUp/routes';
import { FaroRoutes } from 'utils/faro';

import { GlobalStyles } from './GlobalStyles';

export const App = () => {
  return (
    <StylingProvider>
      <PersistentStateProvider>
        <TrackingProvider>
          <UserProvider>
            <DashboardProvider>
              <PluginProvider>
                <RedirectProvider>
                  <Layout>
                    <GlobalStyles />
                    <FaroRoutes>
                      <Route path={`${signUpRoutes.base}/*`} element={<SignUp />} />
                      <Route path={`${signInRoutes.base}/*`} element={<SignIn />} />
                      <Route path={`${invitesRoutes.base}/*`} element={<Invites />} />
                      <Route path={`${mfaLoginRoutes.base}/*`} element={<MfaLogin />} />
                      <Route path={`${mfaRecoveryRoutes.base}/*`} element={<MfaRecovery />} />
                      <Route path={`${mfaSetupRoutes.base}/*`} element={<MfaSetup />} />
                      <Route path={`${forgotPasswordRoutes.base}/*`} element={<ForgotPassword />} />
                      <Route path={`${redirectToRoutes.base}/*`} element={<RedirectTo />} />
                      <Route path={`${grafanaSsoRoutes.base}/*`} element={<GrafanaSso />} />
                      <Route path="/" element={<Navigate replace to={signUpRoutes.base} />} />
                    </FaroRoutes>
                  </Layout>
                </RedirectProvider>
              </PluginProvider>
            </DashboardProvider>
          </UserProvider>
        </TrackingProvider>
      </PersistentStateProvider>
    </StylingProvider>
  );
};
